export interface PainPoint {
  title: string
  lines: string[]
}

export const painIntro: string[] = [
  'You already know how to coach golf.',
  'The problem is everything you have to prepare before and after each lesson.',
  'Which drill should you use?',
  'How should you structure the session?',
  'What should the player practise next?',
  'How will you track their progress?',
  'And next week... you start all over again.',
]

export const painClose =
  "The problem isn't your coaching knowledge. It's the time you spend preparing to coach."

export const painPoints: PainPoint[] = [
  {
    title: '😰 Too Much Time Spent Preparing Lessons',
    lines: [
      'Every golfer needs something different.',
      'Assessment. Drills. Progressions. Practice. Follow-up.',
      'You know what your player needs — but you still have to turn that into a complete session.',
      "And when you're coaching several players every week, those hours add up fast.",
      'What if the material was already prepared for you?',
    ],
  },
  {
    title: '⚠️ Stop Searching For The Right Drill',
    lines: [
      'There are thousands of golf drills online.',
      "That's not the problem.",
      'The problem is finding the right drill for the right player and objective when you actually need it.',
      'Putting. Short game. Wedges. Irons. Driving. Distance control. Course management.',
      'GOLF COACH PRO™ organizes everything so you can find, select, adapt, and coach faster.',
    ],
  },
  {
    title: '⛳ Turn Player Problems Into Better Sessions',
    lines: [
      'Your golfer struggles with distance control.',
      'Or putting.',
      'Or ball striking.',
      'Or decisions on the course.',
      'You identify the problem.',
      'Now you need the session, drills, progression, practice, and follow-up.',
      "Instead of creating all of it yourself, use a system that's already prepared.",
    ],
  },
  {
    title: '😩 Stop Starting From Scratch',
    lines: [
      'Lesson ends.',
      'Review the player.',
      'Plan the next session.',
      'Find the drills.',
      'Create the practice.',
      'Track the progress.',
      'Then repeat.',
      'Golf Coach Pro™ puts that entire process into one organized system.',
    ],
  },
]
